export default function reportTypeDirective() {
  return {
    template: require('./report-type.html'),
    controller: 'MRReportTypeController',
    controllerAs: 'mrReportTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportType: '=',
    },
  };
}
